module.exports = __webpack_public_path__ + "img/w72.55deaf4b.svg";